import {Select} from "@ui";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {adapterBankWithAccount, findBankData, getDataFromAccount} from "../../../../adapters/bankListAdapter";
import useGetAccountPagoMovil from "../../../../hooks/wallet/useGetAccountPagoMovil";
import {useBalanceStore} from "../../../../store/useBalance.store";
import parentStyles from "../WithdrawalSteps.module.css";
import WithdrawalLimits from "./WithdrawalLimits";

const SelectAccount = ({setSelectBankAccount, setIsNextDisabled}) => {
  const {data} = useGetAccountPagoMovil();
  const [accountId, setAccountId] = useState("");
  const handlePagoMovilListModal = useBalanceStore.getState().handlePagoMovilListModal;

  const {t} = useTranslation();

  useEffect(() => {
    setIsNextDisabled?.(true);
  }, [setIsNextDisabled]);

  useEffect(() => {
    if (accountId) {
      const bankSelected = getDataFromAccount(data, accountId);
      if (bankSelected) {
        const bankName = findBankData(bankSelected).bank_name;
        setSelectBankAccount({
          id: bankSelected.ID,
          phone: bankSelected.phone_number,
          bankCode: bankSelected.bank_code,
          bankName: bankName,
        });
      }
    }
  }, [accountId]);

  const handleChange = value => {
    setAccountId(value);
    setIsNextDisabled?.(false);
  };

  return (
    <div>
      <WithdrawalLimits />
      <div className={parentStyles.selectAccountSection}>
        <p className={parentStyles.selectAccountTitle}>{t("withdrawalStepsSelectAccount")}</p>
        <div className={parentStyles.selectAccountRow}>
          <Select
            placeholder={t("withdrawalStepsSelectAccount_select")}
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            style={{width: "100%"}}
            onChange={handleChange}
          >
            {data &&
              adapterBankWithAccount(data).map(item => (
                <Select.Option
                  key={item.value}
                  value={item.value}
                >
                  {item.label}
                </Select.Option>
              ))}
          </Select>
        </div>
        <p className={parentStyles.selectAccountHint}>
          {t("withdrawalStepsSelectAccountDesc2")}
          <span
            className={parentStyles.selectAccountLink}
            onClick={() => handlePagoMovilListModal()}
            role="button"
            tabIndex={0}
            onKeyDown={e => e.key === "Enter" && handlePagoMovilListModal()}
          >
            {t("withdrawalStepsSelectAccountlink")}
          </span>
          .
        </p>
      </div>
    </div>
  );
};

SelectAccount.propTypes = {
  setSelectBankAccount: PropTypes.func.isRequired,
  setIsNextDisabled: PropTypes.func,
};

export default SelectAccount;
